/*
----------------------------
Module - dialog
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.dialog = function(){

        function init() {

            // Has to be body on click because forms can be ajaxed in
            // By doing it this way, don't need to reinitialise click handler
            
            $("body").on("click", "[data-close-dialog]", function() {
                $.magnificPopup.close();
            });
            
        }

        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.dialog.init();
    });

}());